module.exports = __webpack_public_path__ + "img/thumbnail_HermannsTortoise_u_albino.fe6cdade.png";